<template>
  <ModalPage :goBackTo="{name: 'group'}" :canGoBack="canGoBack" v-slot="{finished}">
    <Mutation
      :mutation="mutation"
      :variables="variables"
      @done="onDone"
      @error="onError"
      class="px-4 pt-5 pb-4"
    >

      <template v-slot="{ mutate, loading }">
        <ValidationObserver
          ref="observer"
          v-slot="{ valid, invalid }"
          tag="form"
          @submit.prevent="mutate"
        >


          <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
            <button @click="finished" type="button" class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" aria-label="Close">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                Delete group {{group.name}}?
              </h3>
              <div class="mt-2">
                <p class="text-sm leading-5 text-gray-500 mt-2 italic">
                  Don't worry, the students will still be in Cardstock.
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="submit" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:ring-red transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                Delete
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button @click="finished" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                Cancel
              </button>
            </span>
          </div>


        </ValidationObserver>

      </template>

    </Mutation>
  </ModalPage>
</template>


<script>

import Mutation from '@/components/Mutation.vue'
import SelectDropdown from '@/components/SelectDropdown.vue'
import ModalPage from '@/components/ModalPage.vue'

import { ValidationObserver, ValidationProvider } from "vee-validate"

export default {
  components: {
    ModalPage,
    Mutation,
    SelectDropdown,
    ValidationObserver
  },

  props: {
    canGoBack: {
      type: Boolean,
      default: false
    },

    group: {
      type: Object,
      required: true
    },

    groupId: {
      type: String,
      required: true
    },

    teamId: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      isSubmitting: false,
      mutation: gql`
        mutation ($id: ID!) {
          group_delete (id: $id) {
            id
          }
        }`,
      hasMounted: !(this.canGoBack == true)
    }
  },

  mounted() {
    this.hasMounted = true
  },

  beforeRouteLeave(to, from, next) {
    this.hasMounted = false
    next()
  },

  computed: {
    variables() {
      return {
        id: this.groupId,
      }
    },
  },

  methods: {
    onDone() {
      Bus.$emit('flash-message', {text: 'Group deleted', type: 'success'})
      this.$router.replace({name: 'students'})
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
    },
  }
}
</script>
